import { Projects } from '../../utils/types/Projects';

export const UPDATE_PROJECTS = 'UPDATE_PROJECTS';

export interface UpdateProjectsAction {
	type: typeof UPDATE_PROJECTS;
	payload: Array<{ docId: string; project: Projects }>;
}

export function updateProjects(projects: Array<{ docId: string; project: Projects }>): UpdateProjectsAction {
	return {
		type: UPDATE_PROJECTS,
		payload: projects,
	};
}
